import React,{ useState, useRef, useEffect } from "react"
import "../../assets/css/custom.css"
import { FiSearch } from "react-icons/fi"

const CustomDropdown = ({
  dropdownData,
  dropdownValue,
  setDropdownValue,
  name,
  formValues,
  DataRefechRetrigger,
  errors,
  fieldName,
  eventType,
  FeildName,
  disabled,
  ShouldValidate = true,
  applicationId = 3,
  textboxError,
  data = [],
}) => {
  const [filteredDropdownData, setFilteredDropdownData] = useState(dropdownData)
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [inputValue, setInputValue] = useState("")
  const dropdownRef = useRef(null)

  useEffect(() => {
    if (eventType === "Update" && dropdownValue && !inputValue) {
      const selectedOption = dropdownData.find((option) => {
        if (FeildName === "country" && option.country_name) {
          // Convert both to strings for consistent comparison
          return String(option.id) === String(dropdownValue)
        } else if (FeildName === "clinic_country" && option.country_name) {
          return String(option.id) === String(dropdownValue)
        } else if (FeildName === "state" && option.name) {
          return Number(option.id) === Number(dropdownValue)
        } else if (FeildName === "clinic_state" && option.name) {
          return Number(option.id) === Number(dropdownValue)
        } else if (FeildName === "gender" && option.value) {
          return option.value === dropdownValue
        } else if (FeildName === "zone" && option.value) {
          return option.value === dropdownValue
        } else if (FeildName === "common" && option.name) {
          return Number(option.id) === Number(dropdownValue)
        } else if (
          FeildName === "edu_undergrad_year" ||
          FeildName === "edu_postgrad_year" ||
          FeildName === "edu_superspecialty_year"||
          FeildName === "year_of_fmas"
        ) {
          return Number(option) === Number(dropdownValue)
        } else if (FeildName === "nationality") {
          // Check both nationality and country_name fields
          const optionValue = option.nationality || option.country_name
          return optionValue?.toLowerCase() === String(dropdownValue).toLowerCase()
        }
        return false
      })

      if (selectedOption) {
        if (FeildName === "nationality") {
          setInputValue(selectedOption.nationality || selectedOption.country_name)
        } else {
          setInputValue(
            selectedOption.name ||
              selectedOption.country_name ||
              selectedOption.value ||
              selectedOption.year ||
              selectedOption,
          )
        }
      }
    }
  }, [dropdownData, dropdownValue, eventType, FeildName, inputValue])

  useEffect(() => {
    if (searchQuery) {
      const filteredData = dropdownData.filter((option) => {
        if (FeildName === "country" && option.country_name) {
          return option.country_name.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (FeildName === "clinic_country" && option.country_name) {
          return option.country_name.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (FeildName === "state" && option.name) {
          return option.name.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (FeildName === "clinic_state" && option.name) {
          return option.name.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (FeildName === "gender" && option.value) {
          return option.value.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (FeildName === "zone" && option.value) {
          return option.value.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (FeildName === "common" && option.name) {
          return option.name.toLowerCase().includes(searchQuery.toLowerCase())
        } else if (
          FeildName === "edu_undergrad_year" ||
          FeildName === "edu_postgrad_year" ||
          FeildName === "edu_superspecialty_year"||
          FeildName === "year_of_fmas"
        ) {
          return String(option).includes(searchQuery)
        } else if (FeildName === "nationality") {
          // Check both nationality and country_name fields
          const nationalityMatch =
            option.nationality && option.nationality.toLowerCase().includes(searchQuery.toLowerCase())
          const countryNameMatch =
            option.country_name && option.country_name.toLowerCase().includes(searchQuery.toLowerCase())
          return nationalityMatch || countryNameMatch
        }
        return false
      })
      setFilteredDropdownData(filteredData)
    } else {
      setFilteredDropdownData(dropdownData)
    }
  }, [searchQuery, dropdownData, FeildName])

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value)
  }

  const handleDropdownSelect = (option) => {
    let selectedValue = ""
    if (FeildName === "country") {
      selectedValue = option.country_name
      // Ensure country ID is properly converted to string
      setDropdownValue(option.id ? option.id.toString() : "")
    } else if (FeildName === "clinic_country") {
      selectedValue = option.country_name
      setDropdownValue(option.id ? option.id.toString() : "")
    } else if (FeildName === "state") {
      selectedValue = option.name
      setDropdownValue(option.id.toString())
    } else if (FeildName === "clinic_state") {
      selectedValue = option.name
      setDropdownValue(option.id.toString())
    } else if (FeildName === "gender") {
      selectedValue = option.value
      setDropdownValue(option.value)
    } else if (FeildName === "zone") {
      selectedValue = option.value
      setDropdownValue(option.value)
    } else if (FeildName === "common") {
      selectedValue = option.name
      setDropdownValue(option.id.toString())
    } else if (
      FeildName === "edu_undergrad_year" ||
      FeildName === "edu_postgrad_year" ||
      FeildName === "edu_superspecialty_year"||
      FeildName === "year_of_fmas"
    ) {
      selectedValue = String(option)
      setDropdownValue(option)
    } else if (FeildName === "nationality") {
      // Use nationality if available, otherwise use country_name
      selectedValue = option.nationality || option.country_name
      setDropdownValue(selectedValue)
    }

    setInputValue(selectedValue)
    setSearchQuery("")
    setDropdownVisible(false)
  }

  const handleClearSearch = () => {
    setInputValue("")
    setDropdownValue(null)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false)
        setSearchQuery("")
      }
    }

    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (applicationId !== 3) {
      if (FeildName === "nationality") {
        setDropdownValue("Indian")
        setInputValue("Indian")
      } else if (FeildName === "country") {
        setInputValue("India")
        // Ensure country ID is properly converted to string
        setDropdownValue("101")
      }
    } else if (applicationId === 3 && data?.country_id) {
      if (FeildName === "country") {
        setInputValue(data.country_name)
        // Ensure country ID is properly converted to string
        setDropdownValue(data.country_id ? data.country_id.toString() : "")
      }
    }
  }, [applicationId, FeildName, data?.country_id, data?.country_name])

  return (
    <div className="multiselect_div single_inputdrop" ref={dropdownRef}>
      <div className="input-container" style={{ position: "relative" }}>
        <input
          type="text"
          value={inputValue}
          disabled={disabled}
          onClick={() => !disabled && setDropdownVisible(!isDropdownVisible)}
          className={`form-control ${
            (errors[fieldName] && textboxError) || (errors[fieldName] && ShouldValidate) ? "red_border" : ""
          }`}
          placeholder={`Select ${name}`}
          style={{ paddingRight: "30px", cursor: "pointer" }}
        />
        {inputValue && !disabled && (
          <button
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
            }}
            onClick={handleClearSearch}
          >
            &#x2715;
          </button>
        )}
      </div>

      {isDropdownVisible && !disabled && (
        <div className="dropdown-search-container">
          <ul className="dropdown-list">
            <li>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder={`Search ${name}`}
                  className="dropdown-search-input"
                  style={{ paddingLeft: "30px" }}
                />
                <FiSearch
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </li>
            {filteredDropdownData.map((option) => (
              <li key={option.id || option} onClick={() => handleDropdownSelect(option)}>
                {FeildName === "country"
                  ? option.country_name
                  : FeildName === "state"
                    ? option.name
                    : FeildName === "gender"
                      ? option.value
                      : FeildName === "zone"
                        ? option.value
                        : FeildName === "edu_undergrad_year" ||
                            FeildName === "edu_postgrad_year" ||
                            FeildName === "edu_superspecialty_year"||
                            FeildName === "year_of_fmas"
                          ? option
                          : FeildName === "common"
                            ? option.name
                            : FeildName === "nationality"
                              ? option.nationality || option.country_name
                              : FeildName === "clinic_country"
                                ? option.country_name
                                : FeildName === "clinic_state"
                                  ? option.name
                                  : null}
              </li>
            ))}
          </ul>
        </div>
      )}

      {ShouldValidate && errors && errors[fieldName] && <p className="text-danger pos_abos">{errors[fieldName]}</p>}
    </div>
  )
}

export default CustomDropdown
